import { render, staticRenderFns } from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=template&id=74e07883&scoped=true&"
import script from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=style&index=0&id=74e07883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e07883",
  null
  
)

export default component.exports